module.exports = __webpack_public_path__ + "static/media/vaipe_home.9e5556f4.png";